var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('video',{ref:"video",attrs:{"id":"videoBanner","src":_vm.src,"muted":"","autoplay":"","loop":""},domProps:{"muted":true}}),_c('div',{staticClass:"title"},[_vm._v("城市微场景数据服务及整体解决方案提供商")])])}
var staticRenderFns = []

export { render, staticRenderFns }